




















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { DailyControlForm } from '@/models/dailyControl'
import { EmployeeModel, WorkDescriptionModel } from '@/models/config'

// Components
import { FormCreateEditDailyControl } from '@/components/dailyControl'
import { BvModalEvent } from 'bootstrap-vue'

@Component({
    name: 'ModalCreateEditDailyControl',
    components: {
        FormCreateEditDailyControl
    }
})
export default class ModalCreateEditDailyControl extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) dailyControl!: DailyControlForm
    @Prop({ type: Array, default: () => [] }) employees!: EmployeeModel[]
    @Prop({ type: Array, default: () => [] }) workDescriptions!: WorkDescriptionModel[]

    get title () {
        if (this.actionForm === 'save') {
            return 'Agregar Control diario de Empleados'
        }
        return 'Agregar Control diario de Empleados'
    }

    hideModal (event: BvModalEvent) {
        if (event.trigger === 'backdrop') {
            event.preventDefault()
        } else {
            this.$emit('hide', event)
        }
    }
}
